<template lang="html">
    <div class="popup-overlay">
        <div ref="movableContainer" class="create-inspection-tags-container">
            <div class="create-inspection-popup-header" ref="moveButton" :draggable="true" @mousedown="dragStart"
                @mouseup="dragEnd">
                <p>Inspections</p>
                <i class="close fas fa-times" @click="onCloseClicked()"></i>
            </div>
            <div class="create-inspection-tags-container-body" @click.stop="">
                <span class="section-title">Create following Inspections points for:</span>
                <div class="scrollable-inspections-info">
                    <span v-for="t in tagsToCreateInspection" :key="t.id">{{ t.name }}</span>
                </div>
            </div>
            <div class="create-inspection-tags-container-footer">
                <div class="admin-footer-secondary-btn" :class="{'disabled': isLoading}" @click="onCloseClicked()">Cancel</div>
                <div class="admin-footer-btn" :class="{'disabled': isLoading}" @click="generateHandler()">
                    <i class="fas fa-spinner rotating-spinner" v-if="isLoading"></i>
                    <span v-else>Generate</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HttpService from '../../../utils/httpService'
import { log, warn, error } from '@/utils/debugLogger';
export default {
    name: "CreateInspectionsFromHarvesterPopup",
    data() {
        return {
            isLoading: false,
            isMoving: false,
            initialX: 0,
            initialY: 0,
            xOffset: 0,
            yOffset: 0,
        };
    },
    methods: {
        dragStart(e) {
            this.initialX = e.clientX - this.xOffset;
            this.initialY = e.clientY - this.yOffset;
            if (e.target === this.$refs.moveButton) {
                this.isMoving = true;
                this.$refs.movableContainer.style.transition = "none";
            }
        },
        dragEnd() {
            this.isMoving = false;
            this.$refs.movableContainer.style.transition = "all 0.3s ease";
        },
        mouseMove(e) {
            if (this.isMoving) {
                e.preventDefault();
                let currentX = e.clientX - this.initialX;
                let currentY = e.clientY - this.initialY;
                this.xOffset = currentX;
                this.yOffset = currentY;
                this.setTranslate(currentX, currentY, this.$refs.movableContainer);
            }
        },
        setTranslate(xPos, yPos, el) {
            el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
        },
        onCloseClicked() {
            this.tagsToCreateInspection = [];
            this.$store.state.showCreateInspectionPopup = false;
        },
        generateInspections() {
            // AVA-795: the server reads each master (owner, elements, positions, Lno); the rows only name them.
            HttpService.post({
                url: '/api/forge/inspections/generateInspectionFromTags',
                data: {
                    assetId: this.$store.state.assetId,
                    tags: this.tagsToCreateInspection
                },
            }).then(() => {
                log('✅ Inspections generated successfully');
                this.$dialog.notify.success("Inspections generated successfully.", {
                    position: 'top-right',
                    timeout: 3000
                });
            }).catch((err) => {
                log(err);
            }).finally(() => {
                this.isLoading = false;
                this.onCloseClicked();
            });
        },
        generateHandler() {
            this.isLoading = true;

            log('🚀 Generating Inspections');

            this.generateInspections();
        }
    },
    computed: {
        tagsToCreateInspection: {
            get() {
                return this.$store.state.tagsToCreateInspection;
            },
            set(value) {
                this.$store.state.tagsToCreateInspection = value;
            }
        },
        viewer() {
            return this.$store.state.viewer;
        }
    },
    mounted() {
        document.addEventListener("mousemove", this.mouseMove);
    },
    destroyed() {
        document.removeEventListener("mousemove", this.mouseMove);
    },
}
</script>
<style lang="css">
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    background: #5d5d5d45;
}

.create-inspection-popup {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
}
.create-inspection-tags-container {
    display: flex;
    max-height: 400px;
    width: 400px;
    position: absolute;
    top: 25%;
    left: calc(50% - 150px);
    background-color: white;
    box-shadow: 1px 3px 10px 0 rgb(0 0 0 / 50%);
    border-radius: 5px;
    align-items: center;
    z-index: 10;
    flex-direction: column;
    justify-content: space-between;
}

.create-inspection-tags-container-body .filters-section {
    margin-top: 0;
}

.create-inspection-popup-header {
    background: var(--v-primary-base);
    border-radius: 5px 5px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
    width: -webkit-fill-available;
}

.create-inspection-popup-header p {
    font-weight: bold;
    font-size: 14px;
    margin: 10px;
    color: #f2f2f2;
}

.create-inspection-popup-header .fas.fa-times {
    font-size: 15px;
    color: var(--v-primary-lighten3);
    padding: 5px;
}

.create-inspection-popup-header .fas.fa-times:hover {
    color: white;
}

.create-inspection-tags-container-body {
    display: flex;
    flex-direction: column;
    padding: 10px;
    height: auto;
    max-height: 290px;
    width: -webkit-fill-available;
}

.create-inspection-tags-container-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #e0e0e0;
    width: -webkit-fill-available;
}

.create-inspection-tags-container-footer .admin-footer-btn {
    background-color: var(--v-primary-base);
    color: white;
    padding: 5px 30px;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
}

.create-inspection-tags-container-footer .admin-footer-btn:hover {
    background-color: var(--v-primary-lighten3);
    color: var(--v-primary-base);
}

.create-inspection-tags-container-footer .admin-footer-secondary-btn {
    background-color: #e0e0e0;
    color: black;
    padding: 5px 30px;
    border-radius: 5px;
    margin-left: 10px;
    cursor: pointer;
}

.create-inspection-tags-container-footer .admin-footer-secondary-btn:hover {
    background-color: #c2c2c2;
    color: black;
}

.create-inspection-tags-container .section-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.create-inspection-tags-container .scrollable-inspections-info {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    overflow: auto;
}

.create-inspection-tags-container .scrollable-inspections-info span {
    font-size: 14px;
    font-weight: 600;
}

.admin-footer-btn.disabled,
.admin-footer-btn.disabled:hover,
.admin-footer-secondary-btn.disabled,
.admin-footer-secondary-btn.disabled:hover {
    background-color: #e0e0e0;
    color: black;
    cursor: default;
    user-select: none;
    pointer-events: none;
}
</style>